export default {
  // option的结构一般是 {value, text}
  // 以value的值为id后缀
  // 举例:  {value: "sum", text: "Show Sum Value：SUM"}
  // 'common_options_sum': 'Show Sum Value：SUM',

  // Show More Statistics 下拉多选筛选器的选项
  'common_options_sum': 'Show Sum Value：SUM',
  'common_options_avg_no_null': 'Show Average Value(Remove Null): Avg(≠Null)',
  'common_options_avg_no_null_zero': 'Show Average Value(Remove Null&0): Avg(≠Null&0)',
  'common_options_max': 'Show Maximum Value: Max',
  'common_options_min': 'Show Minimum Value: Min',
  'common_options_count': 'Show Count: Count',
  'common_options_avg': 'Show Average Value: Avg',

  // 其他
  'common_options_value_only': "Value Only",
  'common_options_show_change': "Show Change",
  'common_options_show_dod': "Show DoD",
  'common_options_show_wow': "Show WoW",
  'common_options_show_mom': "Show MoM",
  'common_options_show_sdlw': "Show SDLW",
  'common_options_show_swlm': "Show SWLM",
  'common_options_show_smly': "Show SMLY",

}
